import { render } from "./famousCourseUploadVideo.vue?vue&type=template&id=4b3a574a&scoped=true"
import script from "./famousCourseUploadVideo.vue?vue&type=script&lang=js"
export * from "./famousCourseUploadVideo.vue?vue&type=script&lang=js"

import "./famousCourseUploadVideo.vue?vue&type=style&index=0&id=4b3a574a&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3a574a"]])

export default __exports__